import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { http } from '@itau-loans-www/services'
import { isClient } from '@itau-loans-www/utils'

export const usePendingForm = () => {
  const [isLoading, setIsLoading] = useState(false)

  const handleGetNewOffer = async () => {
    try {
      setIsLoading(true)
      const { url } = await http.proposal.crossSell()
      isClient() && window.location.assign(url)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    handleGetNewOffer
  }
}

export const useAddressFormControl = (data) => {
  const initialValues = {
    city: data?.city?.value ?? '',
    state: data?.state?.value ?? '',
    street: data?.street?.value ?? '',
    number: data?.number?.value ?? '',
    zip_code: data?.zip_code?.value ?? '',
    complement: data?.complement?.value ?? '',
    neighborhood: data?.neighborhood?.value ?? ''
  }

  const {
    control,
    setValue,
    formState: { isValid },
    ...formProps
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues
  })

  return {
    addressFormControl: control,
    addressFormSetValue: setValue,
    addressFormProps: formProps,
    isAddressFormValid: isValid
  }
}

export const useBankDataFormControl = (data) => {
  const initialValues = {
    bank: data?.bank?.value ?? '',
    branch: data?.branch?.value ?? '',
    bank_code: data?.bank_code?.value ?? '',
    account_digit: data?.account_digit?.value ?? '',
    account_number: data?.account_number?.value ?? ''
  }

  const {
    control,
    formState: { isValid },
    ...formProps
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues
  })

  return {
    bankDataFormControl: control,
    bankDataFormProps: formProps,
    isBankDataFormValid: isValid
  }
}

export const usePersonalDataFormControl = (data) => {
  const initialValues = {
    cpf: data?.cpf?.value ?? '',
    name: data?.name?.value ?? '',
    email: data?.email?.value ?? '',
    phone: data?.phone?.value ?? ''
  }

  const {
    control,
    formState: { isValid },
    ...formProps
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues
  })

  return {
    personalDataFormControl: control,
    personalDataFormProps: formProps,
    isPersonalDataFormValid: isValid
  }
}

export const useDocumentFormControl = (data) => {
  const initialValues = {
    state: data?.state?.value ?? '',
    document_type: data?.document_type?.value ?? '',
    document_number: data?.document_number?.value ?? '',
    document_issuer: data?.document_issuer?.value ?? '',
    document_issuer_id: data?.document_issuer_id?.value ?? '',
    document_state: data?.document_state?.value ?? '',
    document_state_id: data?.document_state_id?.value ?? '',
    document_issue_date: data?.document_issue_date?.value ?? ''
  }

  const {
    control,
    formState: { isValid },
    ...formProps
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues
  })

  return {
    documentFormControl: control,
    documentFormProps: formProps,
    isDocumentFormValid: isValid
  }
}
